export default __webpack_public_path__ + "static/media/Sjobo_full.e7d78034.png";